import axios from "axios";
import Swiper from "swiper";
import "swiper/css";

const swiperInstances = [];
let swiperIndex = 0;

// こだわりリンク カルーセル
export const settingSwiper = (swiper, index, isSpPreview = false) => {
  const breakpoint = 767;
  const width = window.innerWidth;
  // SP版のプレビューの場合幅での判定が難しいので固定
  if (isSpPreview || width <= breakpoint) {
    // spの場合は最後プラン/フェアカセットも左寄せで表示したいため、末尾にダミースライドを追加
    const swiperWrapper = swiper.querySelector(".swiper-wrapper");
    const slides = swiper.querySelectorAll(".swiper-slide");
    const slideCount = slides.length;
    const isDummySlide = swiper.querySelector(".dummy-slide");

    if (!isDummySlide && slideCount !== 1) {
      const dummySlide = document.createElement("div");
      dummySlide.style.width = 0;
      dummySlide.style.visibility = "hidden";
      dummySlide.classList.add("swiper-slide", "dummy-slide");
      swiperWrapper.appendChild(dummySlide);
    }

    if (slideCount) {
      swiperWrapper.style.paddingLeft = 0;
    }

    // すでに初期化されているか確認
    if (!swiper.classList.contains("swiper-initialized")) {
      swiperInstances[index] = new Swiper(swiper, {
        slidesPerView: 1.2,
        centeredSlides: slideCount === 1, // スライドが1枚の時はセンターに配置(true)
        allowTouchMove: slideCount !== 1, // スライドが1枚でないときのみ許可する(true)
        on: {
          slideChange() {
            // ダミースライドまでスライドされないように調整
            if (this.activeIndex > this.slides.length - 2) {
              this.slideTo(this.slides.length - 2, 300);
            }
          },
        },
      });
    }
  } else {
    const DummySlide = swiper.querySelector(".dummy-slide");
    if (DummySlide) {
      DummySlide.remove();
    }
    const swiperInstance = swiperInstances[index];
    if (swiperInstance && swiperInstance.destroy) {
      swiperInstances[index].destroy(true, true);
    }
  }

  return true;
};

// コンテンツを取得して反映します
const getContent = (e) => {
  const element = e;

  axios
    .request({
      method: "get",
      url: element.dataset?.url,
    })
    .then((response) => {
      if (response.data) {
        element.innerHTML = response.data;
        const swiper = element.querySelector(".js-kodawari-link-swiper");
        if (swiper) {
          settingSwiper(swiper, swiperIndex);
          swiperIndex++;
        }
      } else {
        element.remove();
      }
    })
    .catch(() => {
      // ネットワークエラーとか then でのエラーとかの時
      element.remove();
    });
};

// こだわりリンクの各コンテンツを非同期で読み込みます
export const loadContents = () => {
  document.querySelectorAll(".kodawari_link").forEach((element) => {
    getContent(element);
  });
};

// 管理画面の場合、リサイズイベントを設定しない
// @see https://github.com/wdpk-plus-creation/webtk/blob/develop/resources/assets/js/admin/common_preview.js#L1
if (!window.preview) {
  // 画面幅変更時カルーセル再設定
  window.addEventListener("resize", () => {
    document
      .querySelectorAll(".js-kodawari-link-swiper")
      .forEach((swiper, index) => {
        if (swiper) {
          settingSwiper(swiper, index);
        }
      });
  });
}
